import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { ProfileDetails } from '../models/profile.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpService) {}

  login(email: string, password: string) {
    return this.http.post(`${URLS.signin}`, {
      email: email,
      password: password,
    });
  }

  refreshToken(payload: any) {
    return this.http.post(`${URLS.refreshToken}`, {
      headerToken: null,
      ...payload,
    });
  }
}
